import { HttpParseResponse } from '@uniqoders/sdk';
import HttpClient from '@uniqoders/sdk/src/HttpClient';
import UserService from './services/UserService';
import AuthService from './services/AuthService';
import User from './objects/User';
import Subscription from '@assets/js/front/checkout/api/objects/Subscription';
import SubscriptionService from '@assets/js/front/checkout/api/services/SubscriptionService';
import StripeService from '@assets/js/front/checkout/api/services/StripeService';
class ApiClient extends HttpClient {
    constructor(uri, headers = {}) {
        super(uri, headers);
        const httpParseResponse = new HttpParseResponse();
        httpParseResponse.setMapObject(this.objects());
        this.httpParseResponse = httpParseResponse;
    }
    objects() {
        return {
            user: (attrs) => new User(attrs),
            subscription: (attrs) => new Subscription(attrs),
        };
    }
    get auth() {
        return new AuthService(this);
    }
    get user() {
        return new UserService(this);
    }
    get subscription() {
        return new SubscriptionService(this);
    }
    get stripe() {
        return new StripeService(this);
    }
}
export default ApiClient;
